var $0c58c085e8473442$exports = {};
$0c58c085e8473442$exports = {
    "colorSwatchPicker": `Vzorky barev`,
    "dropzoneLabel": `M\xedsto pro p\u{159}eta\u{17E}en\xed`,
    "selectPlaceholder": `Vyberte polo\u{17E}ku`,
    "tableResizer": `Zm\u{11B}na velikosti`
};


export {$0c58c085e8473442$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
